import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\app\\[locale]\\investment\\InvestmentPageContent.tsx");
